export { default as Sidenav } from './Sidenav.svelte';

// Register icons
import BubbleIcon from '$icons/messages/BubbleIcon.svelte';
import ChevronIcon from '$icons/Chevron.svelte';
import LockIcon from '$icons/Lock.svelte';
import GlobeIcon from '$icons/GlobeIcon.svelte';
import PolygonIcon from '$icons/PolygonIcon.svelte';
import PolygonIconSimple from '$icons/PolygonIconSimple.svelte';
import ShieldIcon from '$icons/ShieldIcon.svelte';
export const icons = {
  BubbleIcon,
  ChevronIcon,
  LockIcon,
  GlobeIcon,
  PolygonIcon,
  PolygonIconSimple,
  ShieldIcon,
};

export type Icon = typeof icons;
export type IconName = keyof Icon;
